module.exports = __webpack_public_path__ + "static/media/totalPnts_25000_50000.7a8c59ae.png";